module.exports = __webpack_public_path__ + "56d60b8440fbfb772b2b053586d8520f.png";